import {
  QDeleteConfirmationModal,
  QMenuButton,
  QMenuItem,
  QText,
} from "@qualio/ui-components";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteProduct } from "../../hooks/useDeleteProduct";
import { Product } from "@design-controls/types";
import { useCurrentProduct } from "../../hooks/useCurrentProduct";
import useHasPermission from "../../hooks/useHasPermission";
import { useNavigate } from "react-router";
import { UserPermissions } from "../../domain/permissions";

export const ManageProduct: React.FC = () => {
  const { t } = useTranslation();
  const product = useCurrentProduct();
  const permissions = useHasPermission([UserPermissions.MANAGE_PRODUCT]);
  const navigate = useNavigate();

  const { isLoading: isDeleting, mutate: deleteProduct } =
    useDeleteProduct(product);

  const [productToDelete, setProductToBeDelete] = useState<Product | undefined>(
    undefined,
  );

  const onConfigureClick = useCallback(
    () => navigate("../config/edit"),
    [navigate],
  );

  if (!permissions[UserPermissions.MANAGE_PRODUCT]) {
    return null;
  }

  return (
    <>
      <QMenuButton iconName="MoreVertical" variant="icon" data-cy="more-option">
        <QMenuItem data-cy="configure-product" onClick={onConfigureClick}>
          {t("products.manage.actions.configure")}
        </QMenuItem>
        <QMenuItem
          color="red.500"
          data-cy="delete-this-product"
          onClick={() => setProductToBeDelete(product)}
        >
          {t("products.manage.actions.deleteThis")}
        </QMenuItem>
      </QMenuButton>
      <>
        {productToDelete && (
          <QDeleteConfirmationModal
            inProgress={isDeleting}
            title={t("products.delete.modalTitle")}
            message={
              <QText fontSize="sm">
                {t("products.delete.confirmMessage", {
                  productName: product?.name,
                })}
              </QText>
            }
            onConfirm={() => {
              productToDelete &&
                deleteProduct(product.id, {
                  onSuccess: () => {
                    setProductToBeDelete(undefined);
                    navigate("/product");
                  },
                });
            }}
            onClose={() => setProductToBeDelete(undefined)}
          />
        )}
      </>
    </>
  );
};
